export default __webpack_public_path__ + "static/media/Loading.f08599da.gif";